import script from "./RequestsDisconnectionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsDisconnectionsView.vue?vue&type=script&setup=true&lang=js"

import "./RequestsDisconnectionsView.vue?vue&type=style&index=0&id=29af3e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29af3e2c"]])

export default __exports__